export const environment = {
  production: false,
  baseApiUrl: 'https://asystentzdrowia.com',
  externalCalendarUrlApi: 'https://www.doctorvolovyk.jdmsite.com/wp-json/wp/v2',
};
